// import React, { useEffect, useRef, useState } from 'react';
// import { OpsDashboardAction } from '../../../Services/_actions/OpsDashboard/OpsDashboard.actions';
// import SelectDropdown from '../../../components/Shared/SelectDropdown';
// import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
// import {
//   LeadsBySectorAtom,
//   QuetionsBySectorAtom,
//   SectorListByNumberAtom,
//   OrganisationListAtom,
//   userDetailAtom,
//   alertAtom,
//   B2bFormDataAtom,
//   channelListAtom,
//   interveneFilterAtom,
// } from '../../../Services/_states';
// import { Row, Col, Form, Accordion, ToastContainer, Toast } from 'react-bootstrap';
// import CommonTable from '../../Shared/Tables';
// import { useParams, useNavigate } from 'react-router-dom';
// import { dateFormate, isValidPhoneNumber } from '../../../utils/helper';
// import { ConstantActions } from '../../../Services/_actions';
// import ErrorWrapper from '../../Shared/ErrorWrapper/index';
// import ModalForms from '../../Shared/Modals';
// import { InterveneActions } from '../../../Services/_actions/Intervene/intervene.actions';
// import { TableColumns } from './column';
// import SearchBox from '../../Shared/SearchBox/index';
// import ChatBox from '../../LeadWebForm/chatBox';
// import SendTemplateModal from '../../Modals/SendTemplateModal';
// import { CallingModal } from '../../Modals/CallingModal/CallingModal';
// import { BackButton } from '../../Shared/BackButton';
// import TableHeader from '../../Shared/TableHeader';
// import B2bLeadForm from './form';
// import UserProfile from '../userProfile';
// import UserInfo from '../UserInfo';

// const infoIcon = <InfoCircle color="black" size={16} style={{ cursor: 'pointer' }} />;

// export default function OpsVerify() {
//   const actions = OpsDashboardAction();
//   const constantActions = ConstantActions();
//   const interveneActions = InterveneActions();
//   const { phone_number } = useParams();
//   const navigate = useNavigate();
//   const formRef = useRef(null);
//   const [formData, setFormData] = useRecoilState(B2bFormDataAtom);
//   const resetB2bFormData = useResetRecoilState(B2bFormDataAtom);
//   const sectorList = useRecoilValue(SectorListByNumberAtom);
//   const allLeads = useRecoilValue(LeadsBySectorAtom);
//   const [quetions, setQuestions] = useRecoilState(QuetionsBySectorAtom);
//   const [userDetails, setUserDetails] = useRecoilState(userDetailAtom);
//   const channelList = useRecoilValue(channelListAtom);
//   const [interveneFilters, setInterveneFilters] = useRecoilState(interveneFilterAtom);
//   const [isInsertNew, setIsInsertNew] = useState(false);
//   const [isTableShow, setIsTableShow] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedSector, setSelectedSector] = useState(null);
//   const [dropdownKey, setDropdownKey] = useState(['lead_count']);
//   const [formErrors, setFormErrors] = useState({});
//   const [modalShow_temp, setModalShow_temp] = useState(false);
//   const [modalShow_call, setModalShow_call] = useState(false);
//   const [showChatBox, setShowChatBox] = useState(false);

//   const handleSearch = async (e) => {
//     if (isValidPhoneNumber(e)) {
//       actions.getSectorByNumber(e);
//       interveneActions.getSupplierList(e);
//       interveneActions.getSupplierByNumber(e);
//       setFormData({ ...formData, phone_number: e });
//       interveneActions.getUserDetailByNumber({...userDetails,phone_number:e});
//       setUserDetails((prev)=>({ ...prev, phone_number: e }));
//       setSelectedSector(null);
//       setQuestions({});
//     } else {
//       setFormData({ ...formData, phone_number: e });
//     }
//   };

//   const handleSector = (event) => {
//     // resetB2bFormData();
//     setSelectedSector(event);
//     if (event) {
//       let obj = { ...event, phone_number: formData?.phone_number };
//       if (!isInsertNew || !isEditMode) {
//         actions.getLeadsBySector(obj);
//         setIsTableShow(true);
//         setIsInsertNew(false)
//       }
//       actions.getQuetionsBySector(obj);
//     }
//     setFormErrors({ ...formErrors, sector_id: '' });
//     setFormData({ ...formData, sector_id: event?.id });
//   };

//   const onChangeButton = (check) => {
//     setTimeout(() => {
//       setFormData({
//         'L4.1': null,
//         'L5.1': null,
//         'L6.1': null,
//         l1_answers: null,
//         l1_answer_2: null,
//         l2_answers: null,
//         relationship_manager: null,
//         current_patner_feedback: '',
//         current_company: null,
//         supplier_id: null,
//         representative: null,
//         call_back_preference: null,
//         current_patner_feedback_reason: '',
//         prefered_patners: [],
//         phone_number: formData?.phone_number,
//         sector_id: formData?.sector_id,
//       })
//     }, 1)
//     setFormErrors({});
//     setIsTableShow(false);
//     setIsEditMode(check);
//     if (!check) {
//       actions.getSectorByNumber(formData?.phone_number);
//       setDropdownKey(['lead_count']);
//       setIsInsertNew(false);
//     } else {
//       actions.getAllSectors();
//       setDropdownKey([]);
//       setIsInsertNew(true);
//       setSelectedSector(null);
//       setFormData({ ...formData, id: null })
//     }
//   };


//   useEffect(() => {
//     if (phone_number) {
//       handleSearch(phone_number);
//     }
//     constantActions.getOrganisations();
//   }, []);

//   const selectRow = {
//     mode: 'radio',
//     clickToSelect: true,
//     selectColumnStyle: {
//       cursor: 'pointer',
//     },

//     onSelect: (row, isSelect, rowIndex, e) => {
//       setIsInsertNew(true);
//       let companyArr = quetions?.companies_sector_wise?.filter((obj) =>
//         row?.preferred_company?.includes(obj.organisation_id)
//       );
//       setFormData({
//         ...formData,
//         ...row,
//         prefered_patners: companyArr,
//         L4: row?.l1_answers,
//         L5: row?.l1_answer_2,
//         L6: row?.l2_answers,
//       });
//       if (row?.representative)
//         constantActions.getUserMinimalList(row?.representative);
//       formRef.current.scrollIntoView({ behavior: 'smooth' });
//     },
//   };
//   const getAllChannels = async () => {
//     await interveneActions?.getAllChannels();
//   }

//   useEffect(() => {
//     if (channelList?.length >= 1) {
//       setInterveneFilters({
//         ...interveneFilters,
//         channelObj: channelList[0],
//         botNumber: channelList[0]['channel_number'],
//       });
//     }
//   }, [channelList]);

//   useEffect(()=>{
//     getAllChannels();
//   },[])

//   const backButton = () => {
//     return <BackButton  onClick={() => navigate(-1)} />;
//   };
//   return (
//     <>
//       <TableHeader
//         isBackButton={backButton}
//         headerValue={'B2B Form'}
//       />
//       <div >
//         <Row>
//           <Col sm={12} md={6} lg={4} xl={8}>
//             <Row>
//               <Col sm={12} md={6} lg={4} xl={4}>
//                 <Form.Group className="mb-3" controlId="sector">
//                   <Form.Label>Number</Form.Label>
//                   <SearchBox onSearch={handleSearch} value={formData?.phone_number} placeholder="Enter Number" />
//                 </Form.Group>
//               </Col>
//               <Col sm={12} md={6} lg={4} xl={4}>
//                 <Form.Group className="mb-3" controlId="sector">
//                   <Form.Label>
//                     Sector <span className="required-field">*</span>
//                   </Form.Label>
//                   <SelectDropdown
//                     optionsData={sectorList?.sectors}
//                     selectedValue={selectedSector}
//                     placeholder="Select Sector"
//                     OptionLabel="business_type"
//                     OptionValue="id"
//                     label="Sector"
//                     id="Sector"
//                     handleSelect={handleSector}
//                     addOptionLabel={dropdownKey}
//                   />
//                   {formErrors?.sector_id && <ErrorWrapper error={formErrors?.sector_id} />}
//                 </Form.Group>
//               </Col>
//               <Col sm={12} md={6} lg={4} xl={4}>
//                 {' '}
//                 <Form.Group className="mb-3" controlId="custom-switch">
//                   <Form.Label></Form.Label>
//                   <Form.Check
//                     type="switch"
//                     id="custom-switch"
//                     label="Enter New"
//                     // value={isInsertNew}
//                     onChange={(e) => {
//                       onChangeButton(e?.target?.checked);
//                     }}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//             <div className="mt-3 border border-primary">
//               {isTableShow && selectedSector && allLeads && allLeads.length ? (
//                 <div style={{ overflowX: 'auto' }}>
//                   <CommonTable
//                     id={'id'}
//                     columnsData={TableColumns}
//                     rowData={allLeads}
//                     selectRow={selectRow}
//                     style={{ paddingTop: '50px' }}
//                   />
//                 </div>
//               ) : null}
//             </div>
//             <br />
//             <br />
//             <div ref={formRef} >
//               {isInsertNew && (
//                 <B2bLeadForm />
//               )}{' '}
//             </div>
//           </Col>
//           <Col>
//             <Accordion defaultActiveKey={"0"} flush>
//               <Accordion.Item eventKey="0">
//                 <Accordion.Header>User Info</Accordion.Header>
//                 <Accordion.Body>
//                   <UserInfo />
//                 </Accordion.Body>
//               </Accordion.Item>
//             </Accordion>
//           </Col>
//         </Row>
//         <br />
//         <Row className="chat-conversation position-relative"  >
//           <Col xs={12} sm={6} md={8} lg={9} className="chat-card position-absolute top-0 end-0">
//             <ToastContainer position="middle-end">
//               <Toast onClose={() => setShowChatBox(false)} show={showChatBox} delay={3000}>
//                 <Toast.Body>
//                 {channelList.length > 1 && (
//                     <SelectDropdown
//                       optionsData={channelList}
//                       selectedValue={interveneFilters?.channelObj}
//                       placeholder="Select Channel"
//                       label="Select Channel"
//                       id="select-bot"
//                       OptionLabel="channel_number"
//                       OptionValue="channel_number"
//                       handleSelect={(e) => { setInterveneFilters({ ...interveneFilters, channelObj: e, botNumber: e?.channel_number }) }}
//                       isClearable={true}
//                       addOptionLabel={['app_name']}
//                     />
//                   )}
//                   <ChatBox />
//                 </Toast.Body>
//               </Toast>
//             </ToastContainer>
//           </Col>

//           <Col className="button-row">
//             <span style={{ cursor: 'pointer' }}>
//               <svg
//                 onClick={() => {
//                   setModalShow_call(true), setShowChatBox(false);
//                 }}
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="16"
//                 height="16"
//                 fill="currentColor"
//                 className="bi bi-telephone-fill"
//                 viewBox="0 0 16 16"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
//                 />
//               </svg>
//               <svg
//                 onClick={() => {
//                   setModalShow_temp(true), setShowChatBox(false);
//                 }}
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="20"
//                 height="20"
//                 fill="currentColor"
//                 className="bi bi-send-fill"
//                 viewBox="0 0 16 16"
//               >
//                 <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
//               </svg>
//               {showChatBox ? (
//                 <svg
//                   onClick={() => setShowChatBox(!showChatBox)}
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="20"
//                   height="20"
//                   fill="currentColor"
//                   className="bi bi-x-lg"
//                   viewBox="0 0 16 16"
//                 >
//                   <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.438-3.439a.5.5 0 1 1 .708.708L8.707 8l3.439 3.438a.5.5 0 0 1-.708.708L8 8.707l-3.438 3.439a.5.5 0 0 1-.708-.708L7.293 8 3.854 4.562a.5.5 0 0 1 0-.708z" />
//                 </svg>
//               ) : (
//                 <svg
//                   onClick={() => setShowChatBox(!showChatBox)}
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="20"
//                   height="20"
//                   fill="currentColor"
//                   className="bi bi-chat-dots"
//                   viewBox="0 0 16 16"
//                 >
//                   <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
//                   <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125m.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6-3.004 6-7 6a8 8 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a11 11 0 0 0 .398-2" />
//                 </svg>
//               )}
//             </span>
//           </Col>
//         </Row>
//       </div>
//       {modalShow_temp && (
//         <ModalForms
//           show={modalShow_temp}
//           handleClose={(e) => {
//             setModalShow_temp(false);
//           }}
//           modalBody={<SendTemplateModal />}
//           modalHeader={'Send Templates'}
//           modalId={'template_modal'}
//           modalclassName={''}
//           size="md"
//         />
//       )}
//       {modalShow_call && (
//         <ModalForms
//           show={modalShow_call}
//           handleClose={(e) => {
//             setModalShow_call(false);
//           }}
//           modalBody={<CallingModal userDetails={userDetails} />}
//           modalHeader={'Quick Call'}
//           modalId={'calling'}
//           modalclassName={''}
//           size="sm"
//         />
//       )}
//     </>
//   );
// }


import React, { useEffect, useRef, useState } from 'react';
import { OpsDashboardAction } from '../../../Services/_actions/OpsDashboard/OpsDashboard.actions';
import SelectDropdown from '../../../components/Shared/SelectDropdown';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import {
  LeadsBySectorAtom,
  QuetionsBySectorAtom,
  SectorListByNumberAtom,
  OrganisationListAtom,
  userDetailAtom,
  alertAtom,
  B2bFormDataAtom,
  channelListAtom,
  interveneFilterAtom,
} from '../../../Services/_states';
import { Row, Col, Form, Accordion, ToastContainer, Toast, Button } from 'react-bootstrap';
import CommonTable from '../../Shared/Tables';
import { useParams, useNavigate } from 'react-router-dom';
import { dateFormate, isValidNumber, isValidPhoneNumber } from '../../../utils/helper';
import { ConstantActions } from '../../../Services/_actions';
import ErrorWrapper from '../../Shared/ErrorWrapper/index';
import ModalForms from '../../Shared/Modals';
import { InterveneActions } from '../../../Services/_actions/Intervene/intervene.actions';
import { TableColumns } from './column';
import SearchBox from '../../Shared/SearchBox/index';
import ChatBox from '../../LeadWebForm/chatBox';
import SendTemplateModal from '../../Modals/SendTemplateModal';
import { CallingModal } from '../../Modals/CallingModal/CallingModal';
import { BackButton } from '../../Shared/BackButton';
import TableHeader from '../../Shared/TableHeader';
import B2bLeadForm from './form';
import UserProfile from '../userProfile';
import UserInfo from '../UserInfo/index.tsx';
import InfoIcon from '@mui/icons-material/Info';

const infoIcon = <InfoIcon color="black" size={16} style={{ cursor: 'pointer' }} />;

export default function OpsVerify() {
  const actions = OpsDashboardAction();
  const constantActions = ConstantActions();
  const interveneActions = InterveneActions();
  const { phone_number } = useParams();
  const navigate = useNavigate();
  const formRef = useRef(null);
  const [formData, setFormData] = useRecoilState(B2bFormDataAtom);
  const resetB2bFormData = useResetRecoilState(B2bFormDataAtom);
  const sectorList = useRecoilValue(SectorListByNumberAtom);
  const allLeads = useRecoilValue(LeadsBySectorAtom);
  const [quetions, setQuestions] = useRecoilState(QuetionsBySectorAtom);
  const [userDetails, setUserDetails] = useRecoilState(userDetailAtom);
  const channelList = useRecoilValue(channelListAtom);
  const [interveneFilters, setInterveneFilters] = useRecoilState(interveneFilterAtom);
  const [isInsertNew, setIsInsertNew] = useState(false);
  const [isTableShow, setIsTableShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedSector, setSelectedSector] = useState(null);
  const [dropdownKey, setDropdownKey] = useState(['lead_count']);
  const [formErrors, setFormErrors] = useState({});
  const [modalShow_temp, setModalShow_temp] = useState(false);
  const [modalShow_call, setModalShow_call] = useState(false);
  const [showChatBox, setShowChatBox] = useState(false);

  const handleSearch = async (e) => {
    try {
      if ((!isValidNumber(e) && e !== "") || e?.length > 13 ) return;
      setFormData((prev) => ({ ...prev, phone_number: e }));
      setUserDetails((prev) => ({ ...prev, phone_number: e }));
      if (e?.length >= 10 && e?.length <= 13) {
        await actions.getSectorByNumber(e);
        await interveneActions.getSupplierList(e);
        await interveneActions.getSupplierByNumber(e);
        await interveneActions.getUserDetailByNumber({ ...userDetails, phone_number: e });

        setSelectedSector(null);
        setQuestions({});
      }
    } catch (error) {
      console.warn("Error in handleSearch:", error);
    }
  };

  const handleSector = (event) => {
    setSelectedSector(event);
    if (event) {
      let obj = { ...event, phone_number: formData?.phone_number };
      if (!isInsertNew || !isEditMode) {
        actions.getLeadsBySector(obj);
        setIsTableShow(true);
        setIsInsertNew(false);
      }
      actions.getQuetionsBySector(obj);
    }
    setFormErrors({ ...formErrors, sector_id: '' });
    setFormData({ ...formData, sector_id: event?.id });
  };

  const onChangeButton = (check) => {
    setTimeout(() => {
      setFormData({
        'L4.1': null,
        'L5.1': null,
        'L6.1': null,
        l1_answers: null,
        l1_answer_2: null,
        l2_answers: null,
        relationship_manager: null,
        current_patner_feedback: '',
        current_company: null,
        supplier_id: null,
        representative: null,
        call_back_preference: null,
        current_patner_feedback_reason: '',
        prefered_patners: [],
        phone_number: formData?.phone_number,
        sector_id: formData?.sector_id,
      });
    }, 1);
    setFormErrors({});
    setIsTableShow(false);
    setIsEditMode(check);
    if (!check) {
      actions.getSectorByNumber(formData?.phone_number);
      setDropdownKey(['lead_count']);
      setIsInsertNew(false);
    } else {
      actions.getAllSectors();
      setDropdownKey([]);
      setIsInsertNew(true);
      setSelectedSector(null);
      setFormData({ ...formData, id: null });
    }
  };

  useEffect(() => {
    if (phone_number) {
      handleSearch(phone_number);
    }
    // constantActions.getOrganisations();
  }, []);

  const selectRow = {
    mode: 'radio',
    clickToSelect: true,
    selectColumnStyle: {
      cursor: 'pointer',
    },
    onSelect: (row) => {
      setIsInsertNew(true);
      let companyArr = quetions?.companies_sector_wise?.filter((obj) =>
        row?.preferred_company?.includes(obj.organisation_id)
      );
      setFormData({
        ...formData,
        ...row,
        prefered_patners: companyArr,
        L4: row?.l1_answers,
        L5: row?.l1_answer_2,
        L6: row?.l2_answers,
      });
      if (row?.representative) constantActions.getUserMinimalList(row?.representative);
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    },
  };

  const getAllChannels = async () => {
    await interveneActions?.getAllChannels();
  };

  useEffect(() => {
    if (channelList?.length >= 1) {
      setInterveneFilters({
        ...interveneFilters,
        channelObj: channelList[0],
        botNumber: channelList[0]['channel_number'],
      });
    }
  }, [channelList]);

  useEffect(() => {
    getAllChannels();
  }, []);

  const backButton = () => {
    return <BackButton onClick={() => navigate(-1)} />;
  };

  return (
    <>
      <TableHeader isBackButton={backButton} headerValue={'B2B Form'} />
      <div>
        <Row>
          <Col sm={12} md={6} lg={8} xl={8}>
            <Row>
              <Col sm={12} md={6} lg={4} xl={4}>
                <Form.Group className="mb-3" controlId="sector">
                  <Form.Label>Number</Form.Label>
                  <SearchBox onSearch={handleSearch} value={formData?.phone_number} placeholder="Enter Number" />
                </Form.Group>
              </Col>
              <Col sm={12} md={6} lg={4} xl={4}>
                <Form.Group className="mb-3" controlId="sector">
                  <Form.Label>
                    Sector <span className="required-field">*</span>
                  </Form.Label>
                  <SelectDropdown
                    optionsData={sectorList?.sectors}
                    selectedValue={selectedSector}
                    placeholder="Select Sector"
                    OptionLabel="business_type"
                    OptionValue="id"
                    label="Sector"
                    id="Sector"
                    handleSelect={handleSector}
                    addOptionLabel={dropdownKey}
                  />
                  {formErrors?.sector_id && <ErrorWrapper error={formErrors?.sector_id} />}
                </Form.Group>
              </Col>
              <Col sm={12} md={6} lg={4} xl={4}>
                <Form.Group className="mb-3" controlId="custom-switch">
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label="Enter New"
                    onChange={(e) => {
                      onChangeButton(e?.target?.checked);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-3 border border-primary">
              {isTableShow && selectedSector && allLeads && allLeads.length ? (
                <div style={{ overflowX: 'auto' }}>
                  <CommonTable
                    id={'id'}
                    columnsData={TableColumns}
                    rowData={allLeads}
                    selectRow={selectRow}
                    style={{ paddingTop: '50px' }}
                  />
                </div>
              ) : null}
            </div>
            <br />
            <br />
            <div ref={formRef}>{isInsertNew && <B2bLeadForm />}</div>
          </Col>
          <Col>
            <Accordion defaultActiveKey={"0"} flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>User Info</Accordion.Header>
                <Accordion.Body>
                  <UserInfo />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
        <br />
        <Row className="chat-conversation position-relative">
          <Col xs={12} sm={6} md={8} lg={9} className="chat-card position-absolute top-0 end-0">
            <ToastContainer position="middle-end">
              <Toast onClose={() => setShowChatBox(false)} show={showChatBox} delay={3000}>
                <Toast.Body>
                  {channelList.length > 1 && (
                    <SelectDropdown
                      optionsData={channelList}
                      selectedValue={interveneFilters?.channelObj}
                      placeholder="Select Channel"
                      label="Select Channel"
                      id="select-bot"
                      OptionLabel="channel_number"
                      OptionValue="channel_number"
                      handleSelect={(e) => {
                        setInterveneFilters({
                          ...interveneFilters,
                          channelObj: e,
                          botNumber: e?.channel_number,
                        });
                      }}
                      isClearable={true}
                      addOptionLabel={['app_name']}
                    />
                  )}
                  <ChatBox />
                </Toast.Body>
              </Toast>
            </ToastContainer>
          </Col>

          <Col className="button-row">
            <span style={{ cursor: 'pointer' }}>
              <svg
                onClick={() => {
                  setModalShow_call(true), setShowChatBox(false);
                }}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-telephone-fill"
                viewBox="0 0 16 16"
              >
                <path d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
              </svg>
              <svg
                onClick={() => {
                  setModalShow_temp(true), setShowChatBox(false);
                }}
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-send-fill"
                viewBox="0 0 16 16"
              >
                <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
              </svg>
              {showChatBox ? (
                <svg
                  onClick={() => setShowChatBox(!showChatBox)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.438-3.439a.5.5 0 1 1 .708.708L8.707 8l3.439 3.438a.5.5 0 0 1-.708.708L8 8.707l-3.438 3.439a.5.5 0 0 1-.708-.708L7.293 8 3.854 4.562a.5.5 0 0 1 0-.708z" />
                </svg>
              ) : (
                <svg
                  onClick={() => setShowChatBox(!showChatBox)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-chat-dots"
                  viewBox="0 0 16 16"
                >
                  <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                  <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125m.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6-3.004 6-7 6a8 8 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a11 11 0 0 0 .398-2" />
                </svg>
              )}
            </span>
          </Col>
        </Row>
      </div>
      {modalShow_temp && (
        <ModalForms
          show={modalShow_temp}
          handleClose={(e) => {
            setModalShow_temp(false);
          }}
          modalBody={<SendTemplateModal handleCloseModal={() => setModalShow_temp(false)} />}
          modalHeader={'Send Templates'}
          modalId={'template_modal'}
          modalclassName={''}
          size="md"
        />
      )}
      {modalShow_call && (
        <ModalForms
          show={modalShow_call}
          handleClose={(e) => {
            setModalShow_call(false);
          }}
          modalBody={<CallingModal userDetails={userDetails} />}
          modalHeader={'Quick Call'}
          modalId={'calling'}
          modalclassName={''}
          size="sm"
        />
      )}
    </>
  );
}